import React, {Component} from "react";
import "./Docs.css";
import FeaturedListItem from "../../common/FeaturedListItem";
import {Link} from "react-router";
import AnchorLink from "../../common/AnchorLink";

class MocksIndex extends Component {
    render() {
        return (
            <div className="container">
                <div className="row m-b-sm">
                    <div className="col-lg-12">
                        <h1 className="page-header">Help &amp; support</h1>
                        <p>Choose a section for more information.</p>
                    </div>
                </div>

                <div className="row m-b-sm">
                    <div className="col-lg-3 m-t-sm-c-xs m-t-sm-c-sm m-t-sm-c-md">
                        <Link className="btn btn-lg btn-info btn-info-outline btn-block"
                              to="/docs/mocks/getting-started">Getting started</Link>
                    </div>
                    <div className="col-lg-3 m-t-sm-c-xs m-t-sm-c-sm m-t-sm-c-md">
                        <AnchorLink className="btn btn-lg btn-info btn-info-outline btn-block"
                                    anchorName="tutorials">Tutorials</AnchorLink>
                    </div>
                    <div className="col-lg-3 m-t-sm-c-xs m-t-sm-c-sm m-t-sm-c-md">
                        <AnchorLink className="btn btn-lg btn-info btn-info-outline btn-block"
                                    anchorName="config">Configuration</AnchorLink>
                    </div>
                    <div className="col-lg-3 m-t-sm-c-xs m-t-sm-c-sm m-t-sm-c-md">
                        <AnchorLink className="btn btn-lg btn-info btn-info-outline btn-block"
                                    anchorName="general">General</AnchorLink>
                    </div>
                </div>

                <section id="tutorials">
                    <div className="row m-b-md">
                        <div className="col-lg-12">
                            <h2 className="page-subsection">Tutorials</h2>
                        </div>
                    </div>

                    <div className="row">
                        <FeaturedListItem title="FAQs" icon="help" linkText="Learn more" linkTo="/docs/mocks/faq">
                            Frequently asked questions.
                        </FeaturedListItem>

                        <FeaturedListItem title="Getting Started" icon="address" linkText="Let's go!" linkTo="/docs/mocks/getting-started">
                            This guide will help you get up and running quickly.
                        </FeaturedListItem>
                    </div>
                </section>

                <section id="config">
                    <div className="row m-b-md">
                        <div className="col-lg-12">
                            <h2 className="page-subsection">Configuration</h2>
                        </div>
                    </div>

                    <div className="row">
                        <FeaturedListItem title="Simple configuration" icon="cog" linkText="Let's go!" linkTo="/docs/mocks/simple">
                            Simple configuration options (beginner).
                        </FeaturedListItem>
                        <FeaturedListItem title="Advanced configuration" icon="tools" linkText="Let's go!" linkTo="/docs/mocks/advanced">
                            Advanced configuration options, including dynamic scripted responses.
                        </FeaturedListItem>
                    </div>

                    <div className="row">
                        <FeaturedListItem title="API" icon="cloud" linkText="Learn more" linkTo="/docs/mocks/api">
                            Integrate CloudMocks into your CI/CI pipeline by using our HTTP API.
                        </FeaturedListItem>
                        <FeaturedListItem title="Samples" icon="text-document" linkText="View samples" linkTo="/docs/mocks/samples">
                            Looking for inspiration? Just getting started? Check out our samples.
                        </FeaturedListItem>
                    </div>
                </section>

                <section id="general">
                    <div className="row m-b-md">
                        <div className="col-lg-12">
                            <h2 className="page-subsection">General</h2>
                        </div>
                    </div>

                    <div className="row">
                        <FeaturedListItem title="Platform" icon="drive" linkText="Learn more" linkTo="/docs/platform">
                            We process requests across a self-healing network of reliable servers to
                            ensure great uptime, always.
                        </FeaturedListItem>
                        <FeaturedListItem title="About us" icon="heart" linkText="Learn more" linkTo="/docs/about">
                            Learn more about us.
                        </FeaturedListItem>
                    </div>
                </section>
            </div>
        );
    }
}

export default MocksIndex;



// WEBPACK FOOTER //
// ./src/modules/views/docs/MocksIndex.js